import * as React from 'react'
import { Text } from '@chakra-ui/core'

const Title = ({ children, ...rest }: Props) => (
  <Text
    fontSize={['3xl', null, '4xl']}
    lineHeight="shorter"
    mt={[6, 8]}
    mb={[2, 4]}
    fontWeight="xBold"
    as="h1"
    fontFamily="serif"
    {...rest}
  >
    {children}
  </Text>
)
type Props = {
  children: React.ReactNode
}

export default Title
